import * as React from 'react';
import { LoadOptions } from 'app/types-shared';
import { CodeComplexValue } from 'app/area/shared/codetable/types';
import { CodeValuePickerProps } from 'app/area/code-mappings/components/types';
import { CodeFieldWireKey } from 'app/area/code-mappings/types-store';
import { CodeSinglePicker } from 'app/area/code-mappings/common/code-single-picker';
import { getComponentValidation } from 'app/area/code-mappings/common/validation';
import { getManageOptions } from 'app/area/code-mappings/components/get-manage-options';
import { getDisabledValidation } from 'app/area/shared/codetable/item/codetable-item-helpers';
import { caseTypeApplicationId, referenceCodetableId } from 'app/area/code-mappings/constants';

export const CodeValue = (props: CodeValuePickerProps) => {

  const {
    codeItem, externalValue, codetableOptions, translation, readOnly, validation, codetableAccess,
    loadCodetableOptions, loadCodetablesAccess, loadMetadata, loadCategoryOptions, metadata
  } = props;

  const codetableId = codeItem.codetable?.value;
  const codetableKey = CodeFieldWireKey.code;
  const codeCategoryKey = CodeFieldWireKey.codeCategory;
  const codeCategoryValue = codeItem?.[codeCategoryKey]?.value ?? codeItem?.[codetableKey]?.category?.value
    ?? codeItem?.[codetableKey]?.categoryId;
  const categoryOptions = codetableOptions?.[codeCategoryKey]?.codes ?? [];
  const valueItem = {
    ...codeItem?.[codetableKey],
    categoryId: codeCategoryValue
  };
  const canLoadCategoryOptions = !!codeItem?.codetable?.ctg && codeItem?.codetable?.value !== referenceCodetableId;
  const limitFieldsTo = ['code', 'category'];
  const displayNotSelected = true;

  const includeDisabledLabel = metadata?.codetable?.id === codetableId
    && metadata?.features?.disabled
    && translation.include_disabled;

  const onChange = (value: CodeComplexValue<number>) => {
    props.onChange(value);
  };

  const onLoadOptions = (id: string, loadOptionsParams: LoadOptions) => {

    if (!metadata || metadata?.codetable?.id !== codetableId) {
      loadMetadata(codetableId);
    }

    loadCodetableOptions(id, codetableId, loadOptionsParams, { limitFieldsTo, displayNotSelected });

    if (!codetableAccess || codetableAccess.id !== codeItem?.codetable?.value) {
      loadCodetablesAccess(codetableId);
    }
  };

  const onLoadCategoryOptions = (loadOptionsParams: LoadOptions) => {
    loadCategoryOptions(codeCategoryKey, codeItem?.codetable?.value, loadOptionsParams);
  };

  const extraFooterButton = getManageOptions({
    label: translation.manage_options,
    codetable: codeItem.codetable,
    loadOptionsParams: codetableOptions?.code?.loadOptionsParams,
    codetableAccess
  });

  const finalValidation = {
    ...getComponentValidation(codetableId, externalValue, codeItem?.code?.value, validation?.importMappings),
    ...getDisabledValidation(codeItem?.code?.disabled, translation.selected_value_disabled)
  };

  return <CodeSinglePicker
    id={codetableKey}
    label={codeItem.codetable?.description}
    valueItem={valueItem}
    searchRequired={false}
    readOnly={readOnly}
    leafNodeOnly={codeItem.codetable.value === caseTypeApplicationId}
    options={codetableOptions?.[codetableKey]?.codes}
    fetchingOptions={codetableOptions?.[codetableKey]?.fetching || codetableOptions?.[codeCategoryKey]?.fetching}
    onLoadOptions={onLoadOptions}
    onChange={onChange}
    displayCategories={canLoadCategoryOptions}
    onLoadCategoryOptions={canLoadCategoryOptions && onLoadCategoryOptions}
    categoryOptions={canLoadCategoryOptions && categoryOptions}
    categoryId={canLoadCategoryOptions && codeItem?.[codeCategoryKey]?.value}
    translation={translation}
    validation={finalValidation}
    extraFooterButton={extraFooterButton}
    includeDisabledLabel={includeDisabledLabel}
  />;
};
